<ng-container *cignaResponsive="let screen">
  <div [ngClass]="{ 'm-3': screen.isSmallerOrEqual('sm') }">
    <div class="row">
      <div class="col-12">
        <div class="prescription"></div>
        <div
          class="drug-res"
          [ngClass]="screen.isSmallerOrEqual('sm') ? 'pl-2' : 'pl-5'"
        >
          <div class="prescription-drug">
            <strong>
              {{ 'drugNameSearch.prescription_drug_list' | translate }}</strong
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-sm-12">
        <small>{{
          'drugNameSearch.use_this_tool.ifp_title' | translate
        }}</small>
        <cigna-pdl-content
          [ifpCopy]="'drugNameSearch.use_this_tool.ifp' | translate"
        ></cigna-pdl-content>
      </div>
    </div>
    <hr />
    <ng-container *ngIf="screen.isLargerOrEqual('md')">
      <br />
    </ng-container>
    <ng-container *ngIf="screen.isSmallerOrEqual('sm')">
      <h5 class="mb-4 select-drug">
        {{ 'drugNameSearch.select_drug_list' | translate | uppercase }}
      </h5>
    </ng-container>
    <div class="row">
      <div
        class="col-12 col-lg-4 col-xl-3"
        [ngClass]="{ 'pr-0': screen.isSmallerOrEqual('sm') }"
      >
        <ng-container *ngIf="screen.isLargerOrEqual('md')">
          <h5 class="mb-4 select-drug">
            {{ 'drugNameSearch.select_drug_list' | translate | uppercase }}
          </h5>
        </ng-container>
        <select
          cignaSelect
          class="w-100 clr-black"
          [ngClass]="{ 'p-2': screen.isLargerOrEqual('md') }"
          (change)="stateTierChange($event.target.value)"
        >
          <option *ngIf="formType === 'IFP'" disabled selected>
            Select State
          </option>
          <option *ngIf="formType === 'nonIFP'" disabled selected>
            Select Drug List
          </option>
          <option [value]="sdd.value" *ngFor="let sdd of selectDropDownList">
            {{ sdd.display }}
          </option>
        </select>
        <ng-container *ngIf="isSecondaryStateDropShow === true">
          <form [formGroup]="secondaryStateFormGroup">
            <select
              formControlName="secondaryDropControl"
              cignaSelect
              class="w-100 clr-black secondStateDropdown"
              [ngClass]="{ 'p-2': screen.isLargerOrEqual('md') }"
              (change)="stateDrugTypeDropdown($event.target.value)"
            >
              <option *ngIf="formType === 'IFP'" disabled selected value="">
                Select Drug List Type
              </option>
              <option
                *ngFor="let secondarydrop of selectedItem?.drugTypes"
                [value]="secondarydrop.value"
              >
                {{ secondarydrop.label }}
              </option>
            </select>
          </form>
        </ng-container>
      </div>
      <ng-container *ngIf="otherInfo$ | async as otherInfo">
        <ng-container *ngIf="drugTableLoading">
          <div
            class="col-3"
            *ngIf="otherInfo?.createdDate"
            [ngClass]="{
              'select-border':
                otherInfo?.dateUpdated || otherInfo?.scheduledUpdate
            }"
          >
            <div
              class="row justify-content-center"
              [ngClass]="{ 'm-0': screen.isSmallerOrEqual('sm') }"
            >
              <small
                ><b>{{ 'dates.date_created' | translate }}</b></small
              >
            </div>
            <div class="row justify-content-center">
              <small>{{ otherInfo.createdDate | date : 'MM/dd/yyyy' }}</small>
            </div>
          </div>
          <div
            class="col-3"
            *ngIf="otherInfo?.dateUpdated"
            [ngClass]="{
              'select-border': otherInfo?.scheduledUpdate,
              'pad-left-10': screen.isSmallerOrEqual('sm')
            }"
          >
            <div
              class="row justify-content-center"
              [ngClass]="{ 'm-0': screen.isSmallerOrEqual('sm') }"
            >
              <small
                ><b>{{ 'dates.last_update' | translate }}</b></small
              >
            </div>
            <div class="row justify-content-center">
              <small>{{ otherInfo.dateUpdated | date : 'MM/dd/yyyy' }}</small>
            </div>
          </div>
          <div
            class="col-3"
            *ngIf="otherInfo?.scheduledUpdate"
            [ngClass]="{ 'pl-2': screen.isSmallerOrEqual('sm') }"
          >
            <div
              class="row justify-content-center"
              [ngClass]="{ 'm-0': screen.isSmallerOrEqual('sm') }"
            >
              <small
                ><b>{{ 'dates.scheduled_update' | translate }}</b></small
              >
            </div>
            <div class="row justify-content-center">
              <small>{{
                otherInfo.scheduledUpdate | date : 'MM/dd/yyyy'
              }}</small>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <hr />
    <ng-container
      *ngIf="
        (selectedStateCode !== undefined &&
          isSecondaryStateDropShow === false) ||
        (isSecondaryStateDropShow === true && secondaryStateValue !== undefined)
      "
    >
      <cigna-search-box
        #searchBox
        (reset)="drugTableLoading = false; searchAlpha = ''"
        (getDrugList)="
          getDrugList($event);
          searchAlpha = $event;
          showSearchInfo = searchBox.searchedDrugName !== ''
        "
        (callToTypeaHead)="callToTypeaHead($event)"
        [typeaHead]="typeaHead$ | async"
      ></cigna-search-box>
      <div *ngIf="drugTableLoading">
        <ng-container
          *cignaWaitToLoad="drugsList$; let list; errorState: showDrugError"
        >
          <cigna-drug-search-results-table
            (getTherapeuticDrugList)="getTherapeuticDrugList($event)"
            [alphabet]="searchAlpha"
            [selectedDrugList]="list"
            [indicator]="this.formType"
            [selectedItemDropDown]="selectedStateCode"
            [selectedItem]="selectedItem"
            [isClassCodeClicked]="isTherapeuticCode"
            [otherInfo]="otherInfo$ | async"
            [showSearchInfo]="showSearchInfo"
            (getDrugList)="
              getDrugList($event); searchAlpha = $event; showSearchInfo = false
            "
          >
            ></cigna-drug-search-results-table
          >
        </ng-container>
      </div>
      <ng-template #showDrugError>
        <p class="rx-cnt-error">
          There was a problem processing your request. Please try again. If you
          continue to receive this error, contact Customer Service using the
          phone number on your ID card.
        </p>
      </ng-template>
    </ng-container>
  </div>
</ng-container>
